var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutoHeight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2197 6.78115C12.9534 6.51488 12.9292 6.09822 13.1471 5.80461L13.2197 5.72049L15.5871 3.35039C15.7128 3.14201 15.9629 3 16.2509 3C16.503 3 16.726 3.10886 16.862 3.27578L16.9148 3.35073L19.282 5.72049L19.3546 5.80461C19.5482 6.0656 19.5506 6.42381 19.3618 6.6872L19.282 6.78115L19.1979 6.85377C18.9369 7.04742 18.5787 7.04981 18.3153 6.86094L18.2213 6.78115L17 5.56V9.34383L16.9931 9.43288C16.9434 9.75319 16.6296 10 16.2499 10C15.8702 10 15.5565 9.75305 15.5068 9.43272L15.5 9.34367V5.56L14.2803 6.78115L14.1962 6.85377C13.9026 7.07162 13.4859 7.04742 13.2197 6.78115Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2226 17.2188C13.4889 16.9526 13.9055 16.9284 14.1991 17.1462L14.2832 17.2188L15.5029 18.44V14.6563C15.5029 14.2939 15.8386 14 16.2528 14C16.6325 14 16.9464 14.2468 16.9961 14.5671L17.0029 14.6562V18.44L18.2242 17.2188C18.4905 16.9526 18.9072 16.9284 19.2008 17.1462L19.2849 17.2188C19.5512 17.4851 19.5754 17.9018 19.3575 18.1954L19.2849 18.2795L16.9177 20.6493C16.7921 20.8578 16.5419 21 16.2538 21C15.9658 21 15.7157 20.858 15.59 20.6496L13.2226 18.2795C12.9297 17.9866 12.9297 17.5117 13.2226 17.2188Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 3.99219C5.00736 3.99219 4 4.99955 4 6.24219V17.7422C4 18.9848 5.00736 19.9922 6.25 19.9922H10.25C10.6642 19.9922 11 19.6564 11 19.2422C11 18.828 10.6642 18.4922 10.25 18.4922H6.25C5.83579 18.4922 5.5 18.1564 5.5 17.7422V6.24219C5.5 5.82797 5.83579 5.49219 6.25 5.49219H10.25C10.6642 5.49219 11 5.1564 11 4.74219C11 4.32797 10.6642 3.99219 10.25 3.99219H6.25Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutoHeight);
export default ForwardRef;